module.exports = __webpack_public_path__ + "img/icon-warning-icing-red.c9cad15e.svg";